import { useUserEventLogger } from '@repo/tracking-service';
import { Button, Guide, Title } from '@zenterprise-inc/ui';
import { useRouter } from 'next/router';

import Illust2Logos from '@/assets/illust-icons/illust-2logos.svg';
import { COMMON_PATHS } from '@/lib/constants/paths';

const IndisSimpleAuthLookupSection = () => {
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const handleClick = () => {
    sendClickEvent('indis-selectauth_selectauth_simplecert');

    router.push({
      pathname: COMMON_PATHS.간편인증_정보입력,
      query: { from: 'lookup' }
    });
  };

  return (
    <div className="page-padding flex w-full flex-col">
      <Title.Headline title="어떤 방법으로 조회할까요?" size="large" />
      <div className="pb-8" />
      <Guide>
        <Guide.ImageArea>
          <Illust2Logos />
        </Guide.ImageArea>
        <Guide.TextArea>
          <Guide.Title titleType="large" className="text-gray-900">
            간편인증으로 조회하기
          </Guide.Title>
          <Guide.Description className="body-16">카카오톡, 네이버로 가능해요.</Guide.Description>
        </Guide.TextArea>
        <Guide.ButtonArea>
          <Button.Box size="large" state="primary" onClick={handleClick}>
            30초 만에 조회하기
          </Button.Box>
        </Guide.ButtonArea>
      </Guide>
    </div>
  );
};

export default IndisSimpleAuthLookupSection;
